import { render, staticRenderFns } from "./SplitDetailManage.vue?vue&type=template&id=4dbca758&scoped=true"
import script from "./SplitDetailManage.vue?vue&type=script&lang=js"
export * from "./SplitDetailManage.vue?vue&type=script&lang=js"
import style0 from "./SplitDetailManage.vue?vue&type=style&index=0&id=4dbca758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbca758",
  null
  
)

export default component.exports